const translations = {
  en: {
    nav: {
      home: 'Home',
      support: 'Support',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use',
    },
    home: {
      meta: { title: 'LIV Studio' },
      eyebrow: 'Mobile apps by Ivan Lapshev',
      title: 'Apps that make everyday life simpler',
      subtitle:
        'Thoughtful iOS apps for photos, shopping, printing, mindfulness, and life on the road.',
      cta: 'Get support',
      appsTitle: 'Our Apps',
      appStore: 'App Store',
      support: 'Support',
      comingSoon: 'Coming soon',
      version: 'v',
    },
    support: {
      meta: { title: 'LIV Studio — Support' },
      back: 'All apps',
      title: 'Support',
      subtitle:
        'Pick an app and describe your issue — we will reply by email.',
    },
    apps: {
      title: 'Select app',
      hint: 'Which app do you need help with?',
      appStore: 'App Store →',
    },
    form: {
      title: 'Contact Support',
      lead: 'Describe your issue or ask a question — we will reply to',
      name: 'Name',
      namePlaceholder: 'Your name',
      email: 'Email',
      app: 'App',
      subject: 'Subject',
      subjectPlaceholder: 'Briefly describe your question',
      message: 'Message',
      messagePlaceholder:
        'Details: what happened, device, app version…',
      submit: 'Compose email',
      successTitle: 'Email app opened',
      successText:
        'A pre-filled message should open in your email app. Tap Send there to deliver it — we will reply shortly.',
      sendAnother: 'Compose another',
    },
    meta: {
      title: 'LIV Studio',
    },
  },
  ru: {
    nav: {
      home: 'Главная',
      support: 'Поддержка',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use',
    },
    home: {
      meta: { title: 'LIV Studio' },
      eyebrow: 'Мобильные приложения от Ivan Lapshev',
      title: 'Приложения для простых задач каждый день',
      subtitle:
        'iOS-приложения для фото, покупок, печати, осознанности и жизни в дороге.',
      cta: 'Написать в поддержку',
      appsTitle: 'Наши приложения',
      appStore: 'App Store',
      support: 'Поддержка',
      comingSoon: 'Скоро',
      version: 'v',
    },
    support: {
      meta: { title: 'LIV Studio — Поддержка' },
      back: 'Все приложения',
      title: 'Поддержка',
      subtitle:
        'Выберите приложение и опишите проблему — ответим на email.',
    },
    apps: {
      title: 'Выберите приложение',
      hint: 'С каким приложением нужна помощь?',
      appStore: 'App Store →',
    },
    form: {
      title: 'Связаться с поддержкой',
      lead: 'Опишите проблему или задайте вопрос — мы ответим на',
      name: 'Имя',
      namePlaceholder: 'Ваше имя',
      email: 'Email',
      app: 'Приложение',
      subject: 'Тема',
      subjectPlaceholder: 'Кратко опишите вопрос',
      message: 'Сообщение',
      messagePlaceholder:
        'Подробности: что произошло, на каком устройстве, версия приложения…',
      submit: 'Написать письмо',
      successTitle: 'Почтовое приложение открыто',
      successText:
        'Должно открыться письмо с заполненными полями. Нажмите «Отправить» в почтовом приложении — мы ответим в ближайшее время.',
      sendAnother: 'Написать ещё',
    },
    meta: {
      title: 'LIV Studio',
    },
  },
};

export default translations;
